const awsconfig = {
  Auth: {
    Cognito: {
      region: import.meta.env.VITE_AWS_REGION || "us-west-2",
      userPoolId: import.meta.env.VITE_USER_POOL_ID || "your-user-pool-id",
      userPoolClientId:
        import.meta.env.VITE_USER_POOL_CLIENT_ID || "your-client-id",
      loginWith: {
        email: true,
        oauth: {
          domain:
            import.meta.env.VITE_USER_POOL_DOMAIN ||
            "your-cognito-domain.auth.us-west-2.amazoncognito.com",
          scopes: [
            "openid",
            "email",
            "profile",
            "aws.cognito.signin.user.admin",
          ],
          redirectSignIn: [
            import.meta.env.VITE_CLOUDFRONT_DOMAIN ||
              "https://your-domain-url.com/",
            import.meta.env.VITE_APP_DOMAIN || "https://your-domain-url.com/",
          ],
          redirectSignOut: [
            import.meta.env.VITE_CLOUDFRONT_DOMAIN ||
              "https://your-domain-url.com/",
            import.meta.env.VITE_APP_DOMAIN || "https://your-domain-url.com/",
          ],
          responseType: "code" as const,
        },
      },
    },
  },
  API: {
    REST: {
      api: {
        endpoint:
          import.meta.env.VITE_API_ENDPOINT ||
          "https://your-api-gateway-url.execute-api.us-west-2.amazonaws.com/prod",
        region: import.meta.env.VITE_AWS_REGION || "us-west-2",
      },
    },
  },
  // WebSocket configuration for real-time features
  WebSocket: {
    endpoint:
      import.meta.env.VITE_WS_ENDPOINT ||
      "wss://your-websocket-url.execute-api.us-west-2.amazonaws.com/prod",
    region: import.meta.env.VITE_AWS_REGION || "us-west-2",
  },
};

export default awsconfig;
